import { useSessionStorage } from 'Utilities/UseStorage';
import { createContext, useEffect, useState } from 'react';

export type IQuoteContext = {
  products: IProduct[] | null;
  setSending: () => void;
};

const initialState: IQuoteContext = {
  products: [],
  setSending: () => {},
};

export const QuoteContext = createContext(initialState);

export function QuoteContextProvider({ children }: { children: React.ReactNode }) {
  const compVersion = 'v2';
  const sessionStorageKey = 'QuoteWidgetData' + compVersion;
  const expirationMinutes: number = 8 * 60;
  const [quoteData, setQuoteData] = useSessionStorage<IProduct[]>(sessionStorageKey, undefined, expirationMinutes);
  const [sending, setIsSending] = useState<boolean>();

  useEffect(() => {
    if (!sending && !quoteData) getQuoteData();
  }, [sending]);

  const getQuoteData = async () => {
    await fetch('/api/sitecore/NowNavigationAsync/GetQuoteModal')
      .then((res) => res.json())
      .then((result) => {
        if (result) {
          var p = result as IProduct[];
          if (p.length > 0) setQuoteData({ data: p });
        }
        setIsSending(false);
      });
  };
  let shared: IQuoteContext = {
    products: quoteData,
    setSending: () => setIsSending(true),
  };

  return <QuoteContext.Provider value={shared}>{children}</QuoteContext.Provider>;
}
